export const logToDebugConsole = (text: string) => {
  const debugConsole = document.getElementById('debug-console')!
  const newEntry = document.createElement('p')
  const now = new Date()
  newEntry.innerText = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}   ${text}`
  debugConsole.prepend(newEntry)
}